import React, { useEffect } from 'react';
import routes from 'app/routes';

import { useContext } from 'components/Common/PolicyTemplates/Context';
import ViewList from './List/Index';

export default function Main() {
  const { dispatch, actions } = useContext();

  useEffect(() => {
    actions.load(dispatch);
  }, []);

  return (
    <ViewList />
  );
}
